module.exports = __webpack_public_path__ + "img/apple.d3b0963d.png";